import { LANGUAGE, LANGUAGES } from '../Controls.constants'

import { radioGroup } from './radioGroup'

/**
 * @param {string} name
 * @param {string} value
 * @param {Iterable<string>} options
 */
export function language(name, value = LANGUAGE.EN, options = LANGUAGES) {
  return radioGroup(name, value, { options })
}
